module.exports = __webpack_public_path__ + "static/media/Start_Badge.c46d6624.zip";